export enum NotificationLevel {
	LEVEL_SUCCESS = 'LEVEL_SUCCESS',
	LEVEL_INFO = 'LEVEL_INFO',
	LEVEL_NOTIFICATION = 'LEVEL_NOTIFICATION',
	LEVEL_WARNING = 'LEVEL_WARNING',
	LEVEL_ERROR = 'LEVEL_ERROR'
}
